import {lazy} from 'react';

export const CartPageLazy = lazy(()=> import('./CartPage'));
export const HistoryPageLazy = lazy(()=> import('./UserHistoryPage'));
export const FavouritePageLazy = lazy(()=> import('./UserFavouritePage'));
export const DocumentPageLazy = lazy(()=> import('./DocumentPage'));
export const AdvanceSearchPageLazy = lazy(()=> import('./AdvanceSearchPage'));